import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, X } from 'lucide-react';
import { api } from '../lib/api';
import { useI18n } from '../lib/i18n';
import { useAuth, canOpenAgents } from '../lib/auth';

type Alerta = { id: string; platform: 'facebook' | 'instagram'; kind: 'dm' | 'comment'; from_name: string | null; text: string | null; status: string; reason: string | null; received_at: string };

/**
 * BANNER DE REDES (dueño 2026-11-02: "cualquier alerta… que me salga el banner arriba"). Mismo patrón que CocAlertBanner: barra
 * fija arriba de toda la app, solo para quien puede abrir Agents / Marketing. Sale cuando un mensaje o comentario de Facebook /
 * Instagram quedó ESCALADO (necesita una persona) o un envío FALLÓ. Cerrarla la calla 10 minutos en esta pestaña; no cambia nada
 * en el servidor: la alerta se va sola cuando alguien contesta o ignora el mensaje en Marketing → Social.
 */
const SILENCIO_MS = 10 * 60_000;

export function SocialAlertBanner() {
  const { t } = useI18n();
  const { me } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState<{ alerts: Alerta[]; total: number } | null>(null);
  const [calladoHasta, setCalladoHasta] = useState(0);
  const puede = canOpenAgents(me);

  useEffect(() => {
    if (!puede) return;
    const load = () => { api.get<{ alerts: Alerta[]; total: number }>('/api/social/alerts').then(setData).catch(() => undefined); };
    load();
    const h = setInterval(() => { if (!document.hidden) load(); }, 60_000);
    const alVolver = () => { if (!document.hidden) load(); };
    document.addEventListener('visibilitychange', alVolver);
    return () => { clearInterval(h); document.removeEventListener('visibilitychange', alVolver); };
  }, [puede]);

  if (!puede || !data || !data.total || Date.now() < calladoHasta) return null;
  const a = data.alerts[0]!;
  const quien = a.from_name ?? '—';
  const red = a.platform === 'instagram' ? 'Instagram' : 'Facebook';
  return (
    <div className="coc-banner social-banner" role="alert">
      <button className="coc-banner-main" onClick={() => navigate(`/marketing?tab=social&item=${a.id}`)}>
        <span className="coc-banner-tag"><MessageCircle size={12} strokeWidth={1.75} style={{ verticalAlign: 'text-bottom' }} /> {t('mk.alert.tag')}</span>
        <span className="coc-banner-msg">{a.status === 'failed' ? t('mk.alert.failed', { red, who: quien }) : t('mk.alert.needs', { red, who: quien })}{a.text ? `: “${a.text.slice(0, 90)}${a.text.length > 90 ? '…' : ''}”` : ''}</span>
        {data.total > 1 && <span className="coc-banner-more">{t('mk.alert.more', { n: String(data.total - 1) })}</span>}
        <span className="coc-banner-go">{t('mk.alert.open')} →</span>
      </button>
      <button className="coc-banner-x" onClick={() => setCalladoHasta(Date.now() + SILENCIO_MS)} title={t('mk.alert.dismiss')}><X size={14} strokeWidth={1.75} /></button>
    </div>
  );
}
